
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/audience",
      function () {
        return require("private-next-pages/audience/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/audience"])
      });
    }
  